export default __webpack_public_path__ + "static/media/default-image-circle.54b8e646.svg";